import { render, staticRenderFns } from "./EditCampaignImage.vue?vue&type=template&id=9ef85b3e&scoped=true"
import script from "./EditCampaignImage.vue?vue&type=script&lang=js"
export * from "./EditCampaignImage.vue?vue&type=script&lang=js"
import style0 from "./EditCampaignImage.vue?vue&type=style&index=0&id=9ef85b3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef85b3e",
  null
  
)

export default component.exports